import EntityType from "@mapmycustomers/shared/enum/EntityType";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import { Lead, MapEntity } from "@mapmycustomers/shared/types/entity";
import { EntityPin, MultiPin } from "@mapmycustomers/shared/types/map";

type EntityIdSource = Identified & { entity: EntityType };

export const mapEntityIdGetter = <T extends EntityIdSource>(entity: T) =>
  `${entity.entity}:${entity.id}`;

export const annotationIdGetter = (annotation: {
  entityId: MapEntity["id"];
  entityType: MapEntity["entity"];
}) => `${annotation.entityType}:${annotation.entityId}`;

export const mapPinIdGetter = (entity: EntityPin | MultiPin) =>
  `${entity.data.entity}:${entity.data.id}`;
export const multiPinIdGetter = (entity: MultiPin) => entity.id;

export const leadIdGetter = (entity: Lead) => entity.place_id;
